<div [id]="nombreMap" class="map-container">
  <!-- Address Search Bar -->
  <div
    [ngStyle]="{
      display: mapaService?.inputDireccion ? 'block' : 'none',
    }"
    class="address-search-container"
  >
    <mat-card class="search-card">
      <div class="search-input-container">
        <input
          #inputDireccion
          type="text"
          class="search-input"
          placeholder="Buscar dirección..."
          [(ngModel)]="mapaService.direccionElegida"
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
          (input)="onInputChange()"
        />
        <button
          irxBotonIcono
          type="button"
          class="calc-button"
          (click)="calcularDireccion()"
          tooltip="Calcular dirección desde la ubicación del marcador"
          [disabled]="mapaService.loading"
        >
          <mat-icon>my_location</mat-icon>
        </button>
        @if (mapaService.direccionElegida) {
          <button
            irxBotonIcono
            type="button"
            class="clear-button"
            (click)="clearSearch()"
            tooltip="Limpiar"
          >
            <mat-icon>clear</mat-icon>
          </button>
        }
      </div>

      <!-- Suggestions Dropdown -->
      @if (
        mapaService.showSuggestions &&
        mapaService.predicciones &&
        mapaService.predicciones.length > 0
      ) {
        <div class="suggestions-container">
          @for (pred of mapaService.predicciones; track pred) {
            <button
              type="button"
              class="irx-sin-estilo suggestion-item"
              (click)="selectPrediction(pred)"
            >
              <mat-icon>location_on</mat-icon>
              <span>{{ pred }}</span>
            </button>
          }
        </div>
      }
    </mat-card>
  </div>
  <!-- } -->

  <div class="mapa-facil-flotante">
    <div class="row-flex-start" style="gap: 2px">
      @if (currentTrip) {
        <div class="column-center magico-85" style="border-radius: 8px">
          <mat-slider color="primary" max="200" [discrete]="true">
            <input matSliderThumb [(ngModel)]="speed" />
          </mat-slider>
        </div>
        <button
          irxBotonIcono="mapa"
          (click)="toggleTripPlayPause()"
          [tooltip]="tripPaused ? 'Reanudar animación' : 'Pausar animación'"
        >
          <mat-icon>{{ tripPaused ? 'play_arrow' : 'pause' }}</mat-icon>
        </button>
        <button
          irxBotonIcono="mapa"
          (click)="layerToggle('trip')"
          tooltip="Mostrar/ocultar markers del viaje"
        >
          <mat-icon>visibility</mat-icon>
        </button>
      }
      @let clusteringConfig = mapaService.clusteringConfig;
      @if (clusteringConfig.enabled) {
        @if (hayVehiculos) {
          <div class="marker-control-group">
            <button
              irxBotonIcono="mapa"
              alternable
              [activo]="vehiculosHabilitados"
              [tooltip]="'Vehículos (' + contadorVehiculos + ')'"
              tooltipPosition="above"
              (click)="toggleVehiculos()"
            >
              <mat-icon>directions_bus</mat-icon>
            </button>
            <button
              irxBotonIcono="anillo"
              class="cluster-button"
              alternable
              [activo]="vehiculosClusterEnabled"
              style="--color-anillo: #2196f3"
              (click)="toggleVehiculosCluster()"
              [tooltip]="'Agrupar vehículos'"
            ></button>
          </div>
        }
        @if (hayColectivos) {
          <div class="marker-control-group">
            <button
              irxBotonIcono="mapa"
              alternable
              [activo]="colectivosHabilitados"
              [tooltip]="'Colectivos (' + contadorColectivos + ')'"
              tooltipPosition="above"
              (click)="toggleColectivos()"
            >
              <mat-icon>directions_transit</mat-icon>
            </button>
            <button
              irxBotonIcono="anillo"
              class="cluster-button"
              alternable
              [activo]="colectivosClusterEnabled"
              style="--color-anillo: #ff7300"
              (click)="toggleColectivosCluster()"
              tooltip="Agrupar colectivos"
            ></button>
          </div>
        }
        @if (hayTrackers) {
          <div class="marker-control-group">
            <button
              irxBotonIcono="mapa"
              alternable
              [activo]="trackersHabilitados"
              [tooltip]="'Trackers (' + contadorTrackers + ')'"
              tooltipPosition="above"
              (click)="toggleTrackers()"
            >
              <mat-icon>gps_fixed</mat-icon>
            </button>
            <button
              irxBotonIcono="anillo"
              class="cluster-button"
              alternable
              [activo]="trackersClusterEnabled"
              style="--color-anillo: #9c27b0"
              (click)="toggleTrackersCluster()"
              tooltip="Agrupar trackers"
            ></button>
          </div>
        }
        @if (hayActivos) {
          <div class="marker-control-group">
            <button
              irxBotonIcono="mapa"
              alternable
              [activo]="activosHabilitados"
              [tooltip]="'Activos (' + contadorActivos + ')'"
              tooltipPosition="above"
              (click)="toggleActivos()"
            >
              <mat-icon>inventory_2</mat-icon>
            </button>
            <button
              irxBotonIcono="anillo"
              class="cluster-button"
              alternable
              [activo]="activosClusterEnabled"
              style="--color-anillo: #4caf50"
              (click)="toggleActivosCluster()"
              tooltip="Agrupar activos"
            ></button>
          </div>
        }
        @if (hayLuminarias) {
          <div class="marker-control-group">
            <button
              irxBotonIcono="mapa"
              alternable
              [activo]="luminariasHabilitadas"
              [tooltip]="'Luminarias (' + contadorLuminarias + ')'"
              tooltipPosition="above"
              (click)="toggleLuminarias()"
            >
              <mat-icon>lightbulb</mat-icon>
            </button>
            <button
              irxBotonIcono="anillo"
              class="cluster-button"
              alternable
              [activo]="luminariasClusterEnabled"
              style="--color-anillo: #ffc107"
              (click)="toggleLuminariasCluster()"
              tooltip="Agrupar luminarias"
            ></button>
          </div>
        }

        @if (hayAlarmas) {
          <div class="marker-control-group">
            <button
              irxBotonIcono="mapa"
              alternable
              [activo]="alarmasHabilitadas"
              [tooltip]="'Alarmas (' + contadorAlarmas + ')'"
              tooltipPosition="above"
              (click)="toggleAlarmas()"
            >
              <mat-icon>warning</mat-icon>
            </button>
            <button
              irxBotonIcono="anillo"
              class="cluster-button"
              alternable
              [activo]="alarmasClusterEnabled"
              style="--color-anillo: #f44336"
              (click)="toggleAlarmasCluster()"
              tooltip="Agrupar alarmas"
            >
              <!-- <mat-icon>
                {{ alarmasClusterEnabled ? 'blur_on' : 'blur_off' }}
              </mat-icon> -->
            </button>
          </div>
        }
        @if (hayParadas) {
          <button
            irxBotonIcono="mapa"
            tooltip="Paradas"
            tooltipPosition="above"
            (click)="layerToggle('paradas')"
          >
            <mat-icon>hail</mat-icon>
          </button>
        }
        @if (hayPuntosActivos) {
          <button
            irxBotonIcono="mapa"
            tooltip="Puntos activos"
            tooltipPosition="above"
            (click)="layerToggle('puntosActivos')"
          >
            <mat-icon>location_on</mat-icon>
          </button>
        }
        @if (hayPolylines) {
          <button
            irxBotonIcono="mapa"
            tooltip="Recorridos"
            tooltipPosition="above"
            (click)="layerToggle('polylines')"
          >
            <mat-icon>route</mat-icon>
          </button>
        }
        @if (hayHeatmaps) {
          <button
            irxBotonIcono="mapa"
            tooltip="Mapa de calor"
            tooltipPosition="above"
            (click)="layerToggle('heatmaps')"
          >
            <mat-icon>whatshot</mat-icon>
          </button>
        }
      }
    </div>
    @if (mapaService?.editingConfig?.enabled) {
      <!-- Controles de Edición -->
      <div class="editing-controls" style="margin-top: 4px">
        <mat-card>
          <!-- Selector de Tipo de Geometría (solo si enableSelector no es false) -->
          @if (mapaService.editingConfig.enableSelector !== false) {
            <mat-form-field class="geometry-selector no-hint">
              <mat-label>Tipo</mat-label>
              <mat-select
                [(ngModel)]="mapaService.editingConfig.drawingTool"
                [disabled]="mapaService.drawingState.dibujando"
                (selectionChange)="onGeometryTypeChange()"
              >
                @for (
                  tipo of (mapaService.editingConfig.allowedTools ? mapaService.tiposGeometria.filter(t => mapaService.editingConfig.allowedTools!.includes(t.id)) : mapaService.tiposGeometria);
                  track tipo.id
                ) {
                  <mat-option [value]="tipo.id">
                    <mat-icon style="margin-right: 8px">
                      {{ tipo.icono }}
                    </mat-icon>
                    {{ tipo.nombre }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          <!-- Botones de Acción -->
          <div
            class="action-buttons"
            style="
              display: flex;
              gap: 8px;
              flex-wrap: wrap;
              margin: 8px 2px 2px;
            "
          >
            <!-- Botón Dibujar/Parar -->
            <button
              irxBoton="tonal"
              [activo]="
                mapaService.drawingState.dibujando &&
                !mapaService.drawingState.dibujandoHueco
              "
              type="button"
              (click)="toggleDibujar()"
              [disabled]="
                !mapaService.editingConfig.drawingTool ||
                mapaService.drawingState.dibujandoHueco
              "
              [tooltip]="
                mapaService.drawingState.dibujando &&
                !mapaService.drawingState.dibujandoHueco
                  ? 'Parar dibujo'
                  : 'Iniciar dibujo de ' + getTipoNombre()
              "
            >
              <mat-icon>
                {{
                  mapaService.drawingState.dibujando &&
                  !mapaService.drawingState.dibujandoHueco
                    ? 'stop'
                    : getTipoIcono()
                }}
              </mat-icon>
              {{
                mapaService.drawingState.dibujando &&
                !mapaService.drawingState.dibujandoHueco
                  ? 'Parar'
                  : 'Dibujar'
              }}
            </button>

            <!-- Botón Hueco/Parar Hueco (solo para polígonos) -->
            @if (
              mapaService.editingConfig.drawingTool === 'Polygon' &&
              mapaService.editingConfig.allowHoles
            ) {
              <button
                irxBoton="tonal"
                [activo]="mapaService.drawingState.dibujandoHueco"
                type="button"
                (click)="toggleDibujarHueco()"
                [disabled]="
                  mapaService.drawingState.dibujando &&
                  !mapaService.drawingState.dibujandoHueco
                "
                [tooltip]="
                  mapaService.drawingState.dibujandoHueco
                    ? 'Parar dibujo de hueco'
                    : 'Dibujar hueco en polígono'
                "
              >
                <mat-icon>
                  {{
                    mapaService.drawingState.dibujandoHueco
                      ? 'stop'
                      : 'donut_large'
                  }}
                </mat-icon>
                {{
                  mapaService.drawingState.dibujandoHueco
                    ? 'Parar Hueco'
                    : 'Hueco'
                }}
              </button>
            }

            <!-- Botón Borrar Todo -->
            <button
              irxBotonIcono
              tono="peligro"
              type="button"
              (click)="borrarTodo()"
              tooltip="Borrar todo"
            >
              <mat-icon>delete</mat-icon>
            </button>

            <!-- Botón Exportar -->
            <button
              irxBotonIcono="borde"
              tono="primario"
              type="button"
              (click)="exportGeometries()"
              tooltip="Exportar geometrías"
            >
              <mat-icon>file_download</mat-icon>
            </button>
          </div>
        </mat-card>
      </div>
    }
  </div>
  @if (selectorBaseLayer) {
    <div class="selector-mapa">
      <irx-segmentado
        class="map-footer-toggle"
        [value]="tipoMapaBase"
        (change)="cambioDeMapa($event.value)"
      >
        @for (mapa of mapasDisponibles; track mapa.key) {
          <irx-segmento [value]="mapa.key" [tooltip]="mapa.nombre">
            <img
              [src]="mapa.icono"
              [alt]="mapa.nombre"
              style="width: 15px; height: 15px"
            />
          </irx-segmento>
        }
      </irx-segmentado>
    </div>
  }

  <!-- Popup Flotante Genérico -->
  <div id="mapa-facil-popup-container" class="mapa-facil-popup">
    <app-popup-generico
      [visible]="mapaService.popupVisible"
      titulo="Información"
      [datos]="mapaService.popupDatos"
      [tipo]="mapaService.popupTitulo"
      (cerrar)="cerrarPopup()"
    ></app-popup-generico>
  </div>
</div>
